import { createSelector } from "reselect";

export const carburationsSelector = createSelector(
  (state) => {
    const units = state.unitsReducer.units
    const stations = state.companies.stations
    const carburations = state.carburations.carburations.map(carburation => {
      
      return {
        ...carburation,
        stationLabel: stations[carburation.idStation]?.fullName,
        unitNumber: units[carburation.idUnit]?.number,
        isMaintenance: units[carburation.idUnit]?.isMaintenance,
      }
    })
    return carburations
  },
  (carburations) => carburations)

export const sgcCarburationSelector = createSelector(state => {
  const { companies } = state.companies
  const { sgc } = state.sgc

  const nSgc = sgc.map(s => {
    return {
      ...s,
      value: s.id,
      label: `${companies[s.id_company]?.name} - ${ s.name}`
    }
  })
  return nSgc
},
(sgc) => sgc)